import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/OSA.Agustinos/',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      name: 'Twitter/X',
      url: 'https://twitter.com/OSA_Agustinos/',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      )
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/osa.agustinos/',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      )
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@agustinos',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      )
    },
    {
      name: 'Email',
      url: 'mailto:comunicacion@agustinos.es',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      name: 'Web',
      url: 'https://agustinos.es/',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      )
    }
  ];

  return (
    <footer className="bg-white mt-6">
      {/* Redes sociales y botón Colabora */}
      <div className="py-8 px-5">
        {/* Primera fila: Iconos de redes sociales principales */}
        <div className="flex flex-wrap justify-center gap-4 mb-4">
          {socialLinks.slice(0, 4).map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-xl flex items-center justify-center text-white hover:opacity-90 transition-all transform hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, #e62c19 0%, #a01916 100%)',
                boxShadow: '0 4px 10px rgba(230, 44, 25, 0.2)'
              }}
              aria-label={social.name}
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Segunda fila: Iconos adicionales + botón Colabora */}
        <div className="flex flex-wrap justify-center items-center gap-4">
          {socialLinks.slice(4).map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-xl flex items-center justify-center text-white hover:opacity-90 transition-all transform hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, #e62c19 0%, #a01916 100%)',
                boxShadow: '0 4px 10px rgba(230, 44, 25, 0.2)'
              }}
              aria-label={social.name}
            >
              {social.icon}
            </a>
          ))}

          {/* Botón Colabora */}
          <a
            href="https://donaciones.agustinos.es"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 h-12 rounded-xl flex items-center justify-center text-white hover:opacity-90 transition-all transform hover:scale-105 font-semibold text-base"
            style={{
              background: 'linear-gradient(135deg, #e62c19 0%, #a01916 100%)',
              boxShadow: '0 4px 10px rgba(230, 44, 25, 0.2)'
            }}
            aria-label="Colabora con donación"
          >
            <img 
              src="/assets/logo-blanco.png" 
              alt="Agustinos" 
              className="w-6 h-6 mr-2"
            />
            Colabora
          </a>
        </div>
      </div>

      {/* Separador y enlaces legales */}
      <div className="bg-gray-50 py-6 px-5 text-center">
        <div className="border-t border-gray-200 mb-5"></div>
        
        {/* Enlaces en la misma fila */}
        <div className="flex justify-center items-center gap-4 mb-5 flex-wrap">
          <button 
            onClick={() => navigate('/terminos-y-condiciones')}
            className="text-gray-600 hover:text-gray-900 transition-colors text-base font-medium"
          >
            Térm. y condiciones
          </button>
          <span className="text-gray-400">·</span>
          <button 
            onClick={() => navigate('/politica-de-privacidad')}
            className="text-gray-600 hover:text-gray-900 transition-colors text-base font-medium"
          >
            Política de privacidad
          </button>
        </div>
        
        <div className="text-sm text-gray-500">
          © Agustinos 2020 - 2026
        </div>
      </div>
    </footer>
  );
};

export default Footer;